var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreaterArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    draggable: "false",
    width: 12,
    height: 22,
    viewBox: "0 0 12 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.30213 0.223161C1.15329 0.0743246 0.967244 -9.44403e-05 0.762593 -9.44225e-05C0.557941 -9.44046e-05 0.371895 0.0743246 0.223058 0.223161C-0.0746164 0.520835 -0.0746163 1.00456 0.223058 1.30223L9.71143 10.7906L0.22306 20.279C-0.0746146 20.5766 -0.0746146 21.0604 0.22306 21.358C0.520734 21.6557 1.00446 21.6557 1.30213 21.358L11.3486 11.3301C11.6463 11.0325 11.6463 10.5487 11.3486 10.2511L1.30213 0.223161Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreaterArrow);
export default __webpack_public_path__ + "static/media/greater-arrow.1a5b6ff8.svg";
export { ForwardRef as ReactComponent };